<template>
    <DButton
        id="mail-interceptor"
        v-c-tooltip="__('messages.header.mail_interceptor.title')"
        icon="email-outline"
        @click="goToMailInterceptor"
    />
</template>

<script setup>
import DButton from '~@/Components/Common/DButton'

const props = defineProps({
    mailCatcherUrl: {
        type: String,
        default: ''
    }
})

const goToMailInterceptor = () => {
    window.open(props.mailCatcherUrl, '_blank').focus()
}
</script>

<style scoped lang="scss">

</style>
